<template>
  <main-container>
    <main-header />

    <indicador-navegacao />

    <form-container>
      <form-input-grupo tituloGrupo="Emissão de NFC-E">
        <form-input-individual>
          <label class="form-pergunta-titulo">Você trabalha com emissão de Nota Fiscal de Consumidor Eletrônica (NFC-e)? *</label>
          <div id="emiteNFCE">
            <div class="custom-control custom-radio">
              <input class="custom-control-input" type="radio" id="emite-nfce" :value="true" v-model="emiteNFCE" />
              <label class="custom-control-label" for="emite-nfce">Sim, emito NFC-e</label>
            </div>
            <div class="custom-control custom-radio">
              <input class="custom-control-input" type="radio" id="nao-emite-nfce" :value="false" v-model="emiteNFCE" />
              <label class="custom-control-label" for="nao-emite-nfce">Não trabalho com NFC-e</label>
            </div>
          </div>
        </form-input-individual>
      </form-input-grupo>

      <form-buttons
        @voltar-form-anterior="voltarFormAnterior()"
        @avancar-proximo-form="avancarProximoForm(objetoValidacao, montaObjetoCommit, 'commit', 'setDataEmpresaPT7P1', rotaDinamica)"
      />
    </form-container>
  </main-container>
</template>

<script>
export default {
  data() {
    return {
      emiteNFCE: '',
    };
  },
  computed: {
    rotaDinamica() {
      return this.emiteNFCE ? '/fiscal/nfce/dados' : '/conferencia';
    },
    objetoValidacao() {
      const dados = [];
      dados.push(this.montaObjetoValidacao(['campoObrigatorio'], this.emiteNFCE, 'emiteNFCE'));
      return dados;
    },
    montaObjetoCommit() {
      return {
        emiteNFCE: this.emiteNFCE,
      };
    },
  },
  methods: {
    inicializaDados() {
      this.emiteNFCE = this.$store.state.dadosNavegacao.tipoNFCE;
    },
  },
  created() {
    this.inicializaDados();
  },
};
</script>

<style></style>
